module.exports = __webpack_public_path__ + "img/prop-tree-2.022758e3.webp";